import React from 'react';
import { Box, IconButton, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { IconPlus } from '@tabler/icons';
import { CaseThread } from '../../../types/support.types';

interface CaseThreadSelectorProps {
  threads: CaseThread[];
  selected: string;
  onSelect: (id: string) => void;
  onNewThread: () => void;
}

const ORIGIN_LABEL: Record<string, string> = {
  app: 'App',
  email: 'Email',
  slack: 'Slack',
};

const CaseThreadSelector: React.FC<CaseThreadSelectorProps> = ({
  threads,
  selected,
  onSelect,
  onNewThread,
}) => {
  const selectedIndex = threads.findIndex((t) => t.id === selected);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Tabs
        value={selectedIndex >= 0 ? selectedIndex : 0}
        onChange={(_e, idx) => onSelect(threads[idx].id)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ flex: 1, minHeight: 36 }}
      >
        {threads.map((thread) => (
          <Tab
            key={thread.id}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <span>{thread.label}</span>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.65rem' }}
                >
                  ({ORIGIN_LABEL[thread.origin] || thread.origin})
                </Typography>
              </Box>
            }
            sx={{ minHeight: 36, py: 0.5, textTransform: 'none' }}
          />
        ))}
      </Tabs>
      <Tooltip title="New Thread">
        <IconButton size="small" onClick={onNewThread} sx={{ ml: 0.5 }}>
          <IconPlus size={16} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CaseThreadSelector;
